import * as React from "react";
import { Pressable, Text, View } from "react-native";
import { useRouter } from "expo-router";

import { ColorSettingsSwitcher } from "~/components/ColorSettings";
import { supabaseClient } from "~/lib/supabase";
import { useGlobalStore } from "~/stores/global";
import { mmkv } from "~/stores/mmkvStorageAdapter";
import { useAccountStore } from "~/stores/space";
import { Button } from "~/ui/Button";

export default function Account() {
  const { auth } = supabaseClient;
  const { clearStore } = useGlobalStore(true);
  const { replace } = useRouter();
  const [_, refresh] = React.useState(0);
  const { store } = useAccountStore();
  return (
    <View className="container gap-4 pt-4">
      <Button
        variant="secondary"
        onPress={() => {
          auth.signOut().then(() => {
            replace("/(app)/auth/login");
          });
        }}
        size="small"
      >
        Logout
      </Button>
      <View className="flex-row items-center justify-between">
        <Text className="text-input-label font-semibold">Color settings:</Text>
        <ColorSettingsSwitcher />
      </View>
      <View className="mx-8"></View>
      <Text className="text-text-primary font-bold">Debug stuff:</Text>
      <Text className="text-text-primary text-xs">Current account id:</Text>
      <Text className="text-text-primary text-xs">{store.id}</Text>
      <Text className="text-text-primary font-medium">Root store:</Text>
      <Pressable onPress={() => clearStore()}>
        <Text className="text-text-primary text-xs">
          - Reset root store (clears root mobx and MMKV storage and re-fetches
          accounts list)
        </Text>
      </Pressable>
      <Text className="text-text-primary font-medium">MMKV:</Text>
      <Pressable
        onPress={() => {
          mmkv.clearAll();
          refresh((i) => i + 1);
        }}
      >
        <Text className="text-text-primary text-xs">
          - Clear all MMKV storage (does not refresh MobX stores until physical
          reload)
        </Text>
      </Pressable>
      <Text className="text-text-primary font-medium">
        Inspect MMKV Store keys (console log):
      </Text>
      {mmkv.getAllKeys().map((key) => (
        <Pressable
          key={key}
          onPress={() =>
            console.log(
              `MMKV key ${key}`,
              JSON.stringify(mmkv.getString(key), null, 2),
            )
          }
        >
          <Text key={key} className="text-text-primary text-xs">
            - {key}
          </Text>
        </Pressable>
      ))}
    </View>
  );
}
